<template>
    <div class="container px-1 mx-auto">
        <section class="mb-32 text-gray-800">
            <div class="relative overflow-hidden bg-no-repeat bg-cover" style="background-position: 50%; background-image: url('https://i.natgeofe.com/k/57f627c4-44b3-4dd6-90e1-9762bdfd03f6/deserts-palm_3x2.jpg'); height: 300px;"></div>
            <div class="container px-1 text-gray-800 md:px-12">
                <div class="block px-1 py-10 rounded-lg shadow-lg md:py-6 md:px-6" style="margin-top: -100px; background: hsla(0, 0%, 100%, 0.8); backdrop-filter: blur(30px);">
                    <div class="px-1 rounded-lg">
                        <div class="flex flex-wrap justify-between mb-2">
                            <h2 class="w-full pl-2 text-2xl font-bold lg:w-6/12 sm:w-full md:w-6/12">
                                CUCI OpenData - สะสางดอกเบี้ย
                            </h2> 
                            <div class="max-w-4xl pl-2 mt-1 text-right sm:w-full md:w-1/2 lg:w-1/2">
                                <router-link to="/openDataRibaMain">
                                    <button  class="px-2 py-1 ml-1 font-bold text-white bg-gray-600 rounded btn-sm">
                                        <i class="w-5 h-5 fa-solid fa-home"> </i>
                                    </button>
                                </router-link>
                            </div>
                        </div>
                    </div>
                    <div class="flex flex-wrap text-2xl bg-orange-300 flexcc-top">
                        <div class="flex text-black">
                            <span> ข้อมูลการบริจาค [ยอดสะสมทั้งหมด]</span>
                        </div>
                    </div>
                    <div class="flex grid items-center w-full lg:grid-cols-3 md:grid-cols-2 xl:grid-cols-4 sm:grid-cols-1">
                        <div class="flex items-center justify-center max-w-sm p-3 m-4 space-y-2 bg-white bg-orange-200 shadow-lg rounded-xl sm:py-4 sm:space-y-0 sm:space-x-6" style="min-height: 100px;">
                            <div class="p-3 mr-4 text-orange-500 rounded-full bg-orange-50 dark:text-orange-100 dark:bg-orange-500">
                                <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                                    <path fill-rule="evenodd" d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z" clip-rule="evenodd"></path>
                                </svg>
                            </div>
                            <div>
                                <p class="mb-2 text-sm font-medium text-gray-600 dark:text-gray-400">
                                จำนวนการโอน (ครั้ง)
                                </p>
                                <p class="text-lg font-semibold text-gray-700 dark:text-gray-200">86,619</p>
                            </div>
                        </div>
                        <div class="flex items-center justify-center max-w-sm p-3 m-4 space-y-2 bg-white bg-orange-200 shadow-lg rounded-xl sm:py-4 sm:space-y-0 sm:space-x-6" style="min-height: 100px;">
                            <div class="p-3 mr-4 text-orange-500 rounded-full bg-orange-50 dark:text-orange-100 dark:bg-orange-500">
                                <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                                    <path fill-rule="evenodd" d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z" clip-rule="evenodd"></path>
                                </svg>
                            </div>
                            <div>
                                <p class="mb-2 text-sm font-medium text-gray-600 dark:text-gray-400">
                                จำนวนเงิน (บาท)
                                </p>
                                <p class="text-lg font-semibold text-gray-700 dark:text-gray-200">5,369,401.34</p>
                            </div>
                        </div>
                        <div class="flex items-center justify-center max-w-sm p-3 m-4 space-y-2 bg-white bg-orange-200 shadow-lg rounded-xl sm:py-4 sm:space-y-0 sm:space-x-6" style="max-height: 100px;">
                            <div class="p-3 mr-4 text-orange-500 rounded-full bg-orange-50 dark:text-orange-100 dark:bg-orange-500">
                                <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                                    <path fill-rule="evenodd" d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z" clip-rule="evenodd"></path>
                                </svg>
                            </div>
                            <div>
                                <p class="mb-2 text-sm font-medium text-gray-600 dark:text-gray-400">
                                งบประมาณที่อนุมัติโครงการ (บาท)
                                </p>
                                <p class="text-lg font-semibold text-gray-700 dark:text-gray-200">3,327,246</p>
                            </div>
                        </div>
                        <div class="flex items-center justify-center max-w-sm p-3 m-4 space-y-2 bg-white bg-orange-200 shadow-lg rounded-xl sm:py-4 sm:space-y-0 sm:space-x-6" style="min-height: 100px;">
                            <div class="p-3 mr-4 text-orange-500 rounded-full bg-orange-50 dark:text-orange-100 dark:bg-orange-500">
                                <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                                    <path fill-rule="evenodd" d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z" clip-rule="evenodd"></path>
                                </svg>
                            </div>
                            <div>
                                <p class="mb-2 text-sm font-medium text-gray-600 dark:text-gray-400">
                                โครงการที่อนุมัติงบ
                                </p>
                                <p class="text-lg font-semibold text-gray-700 dark:text-gray-200">36</p>
                            </div>
                        </div>
                        <div class="flex items-center justify-center max-w-sm p-3 m-4 space-y-2 bg-white bg-orange-200 shadow-lg rounded-xl sm:py-4 sm:space-y-0 sm:space-x-6" style="min-height: 100px;">
                            <div class="p-3 mr-4 text-orange-500 rounded-full bg-orange-50 dark:text-orange-100 dark:bg-orange-500">
                                <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                                    <path fill-rule="evenodd" d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z" clip-rule="evenodd"></path>
                                </svg>
                            </div>
                            <div>
                                <p class="mb-2 text-sm font-medium text-gray-600 dark:text-gray-400">
                                งบประมาณที่ได้จ่ายแล้ว (บาท)
                                </p>
                                <p class="text-lg font-semibold text-gray-700 dark:text-gray-200">3,304,936</p>
                            </div>
                        </div>
                        <div class="flex items-center justify-center max-w-sm p-3 m-4 space-y-2 bg-white bg-orange-200 shadow-lg rounded-xl sm:py-4 sm:space-y-0 sm:space-x-6" style="min-height: 100px;">
                            <div class="p-3 mr-4 text-orange-500 rounded-full bg-orange-50 dark:text-orange-100 dark:bg-orange-500">
                                <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                                    <path fill-rule="evenodd" d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z" clip-rule="evenodd"></path>
                                </svg>
                            </div>
                            <div>
                                <p class="mb-2 text-sm font-medium text-gray-600 dark:text-gray-400">
                                งบประมาณที่ยังไม่ได้จ่าย (บาท)
                                </p>
                                <p class="text-lg font-semibold text-gray-700 dark:text-gray-200">30,814</p>
                            </div>
                        </div>
                        <div class="flex items-center justify-center max-w-sm p-3 m-4 space-y-2 bg-white bg-orange-200 shadow-lg rounded-xl sm:py-4 sm:space-y-0 sm:space-x-6" style="min-height: 100px;">
                            <div class="p-3 mr-4 text-orange-500 rounded-full bg-orange-50 dark:text-orange-100 dark:bg-orange-500">
                                <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                                    <path fill-rule="evenodd" d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z" clip-rule="evenodd"></path>
                                </svg>
                            </div>
                            <div>
                                <p class="mb-2 text-sm font-medium text-gray-600 dark:text-gray-400">
                                ยอดคงเหลือโครงการใหม่
                                </p>
                                <p class="text-lg font-semibold text-gray-700 dark:text-gray-200">?</p>
                            </div>
                        </div>
                        <div class="flex items-center justify-center max-w-sm p-3 m-4 space-y-2 bg-white bg-orange-200 shadow-lg rounded-xl sm:py-4 sm:space-y-0 sm:space-x-6" style="min-height: 100px;">
                            <div class="p-3 mr-4 text-orange-500 rounded-full bg-orange-50 dark:text-orange-100 dark:bg-orange-500">
                                <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                                    <path fill-rule="evenodd" d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z" clip-rule="evenodd"></path>
                                </svg>
                            </div>
                            <div>
                                <p class="mb-2 text-sm font-medium text-gray-600 dark:text-gray-400">
                                จำนวนวันที่เปิดสะสาง (วัน)
                                </p>
                                <p class="text-lg font-semibold text-gray-700 dark:text-gray-200">2,022</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>